import { render, staticRenderFns } from "./memberIntegralRule.vue?vue&type=template&id=0879fced&scoped=true&"
import script from "./memberIntegralRule.vue?vue&type=script&lang=js&"
export * from "./memberIntegralRule.vue?vue&type=script&lang=js&"
import style0 from "./memberIntegralRule.vue?vue&type=style&index=0&id=0879fced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879fced",
  null
  
)

component.options.__file = "memberIntegralRule.vue"
export default component.exports